<div [attr.id]="mapId" class="map-container" [class.small]="small" [style.height]="mapHeight" #map></div>